import { Component, OnInit } from '@angular/core';
import { Store } from '@softline/core';
import { BehaviorSubject } from 'rxjs';
import { Lagerartikel } from '../../types/lagerartikel';
import { MessageBarStore, Modal, SOFTLINE_FEATURE_MESSAGE_BAR, UiCoreModule } from '@softline/ui-core';
import { LagerartikelService } from '../../services/lagerartikel.service';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'soft-lagerartikel-dialog',
    templateUrl: './lagerartikel-dialog.component.html',
    styleUrls: ['./lagerartikel-dialog.component.scss'],
    imports: [CommonModule, UiCoreModule]
})
export class LagerartikelDialogComponent implements OnInit, Modal<Lagerartikel | null> {

  readonly loading$ = new BehaviorSubject(false);
  readonly lagerartikel$ = new BehaviorSubject<Lagerartikel[]>([]);

  close!: (result: (Lagerartikel | null)) => void;

  constructor(
      private readonly store: Store,
      private readonly service: LagerartikelService
    ) { }

  async ngOnInit(): Promise<void> {
    this.loading$.next(true);

    try {
      const result = await this.service.getLagerartikel();
      this.lagerartikel$.next(result);
      this.loading$.next(false);
    } catch (e) {
      this.loading$.next(false);
      await this.store.dispatch(
        SOFTLINE_FEATURE_MESSAGE_BAR,
        MessageBarStore.actions.error,
        {
          title: 'Fehler',
          message: 'Lagerartikel konnten nicht geladen werden!'
        }
      );
    }
  }

  registerCloseHandler(handler: (result: (Lagerartikel | null)) => void) {
    this.close = handler;
  }

  async select(artikel: Lagerartikel): Promise<void> {
    this.close(artikel);
  }
}
